 const state = {
  collectRefresh:false,
  center:'',
  drops:''
}

export default state



// WEBPACK FOOTER //
// ./src/store/state.js